import { AthleteAppointmentAthleteRetrieve } from 'types';

export type AthleteAppointmentState =
  | 'noRelation'
  | 'reserved'
  | 'reservedUncredited'
  | 'reservedAndCheckedIn'
  | 'notReservedButCheckedIn'
  | 'lateCancelWithCreditDeduction'
  | 'lateCancelWithoutCreditDeduction'
  | 'noShowWithCreditDeduction'
  | 'noShowWithoutCreditDeduction';

export default function useAthleteAppointmentState(
  athleteAppointment: AthleteAppointmentAthleteRetrieve | undefined,
): AthleteAppointmentState {
  if (!athleteAppointment) {
    return 'noRelation';
  }

  const { isReserved, isCheckedIn, isLateCancel, isNoShow, isCredited } = athleteAppointment;

  if (isNoShow) {
    return isCredited ? 'noShowWithCreditDeduction' : 'noShowWithoutCreditDeduction';
  }

  if (isLateCancel) {
    return isCredited ? 'lateCancelWithCreditDeduction' : 'lateCancelWithoutCreditDeduction';
  }

  if (isCheckedIn) {
    return isReserved ? 'reservedAndCheckedIn' : 'notReservedButCheckedIn';
  }

  if (isReserved) {
    return isCredited ? 'reserved' : 'reservedUncredited';
  }

  return 'noRelation';
}
